<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="teacherReportForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                              Report
                            </b></h3>
                    </div>
                </div>

                <hr>
                <div  class="row clearfix">
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Session</mat-label>
                            <mat-select #selectSession placeholder="Session" class="colorblack" formControlName="SessionId" required>
                                <mat-select-filter *ngIf="selectSession.focused" [placeholder]="'Filter'"
                                    [displayMember]="'SnName'" [array]="sessionList"
                                    (filteredReturn)="SessionFilterList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                                    {{item.SnName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherReportForm.controls['SessionId'].touched && teacherReportForm.controls['SessionId'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Course</mat-label>
                            <mat-select #select122 placeholder="Course" formControlName="CoCode" required
                                [disabled]="!teacherReportForm.get('SessionId').value">
                                <mat-select-filter *ngIf="select122.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="CourseList"
                                    (filteredReturn)="filteredListCourse = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCgCoCode">
                                    {{item.CoCgCoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="teacherReportForm.get('CoCode').hasError('required')">
                                Course is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>College</mat-label>
                            <mat-select #selectCollege placeholder="College" formControlName="College" required
                                [disabled]="!teacherReportForm.get('CoCode').value">
                                <mat-select-filter *ngIf="selectCollege.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CgName'" [array]="collegeList"
                                    (filteredReturn)="filteredCollegeList = $event">
                                </mat-select-filter>
                                 <mat-option [value]="0"> All</mat-option>
                                <mat-option *ngFor="let item of filteredCollegeList" [value]="item.CgCode">
                                    {{item.CgCode}} - {{item.CgName}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="teacherReportForm.get('College').hasError('required')">
                                College is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Subject</mat-label>
                            <mat-select required #select123 placeholder="" class="colorblack" formControlName="SubCode"
                                [disabled]="!teacherReportForm.get('College').value">
                                <mat-select-filter *ngIf="select123.focused" [placeholder]="'Filter'"
                                    [displayMember]="'EsName'" [array]="subjectList"
                                    (filteredReturn)="filteredsubjectList = $event">
                                </mat-select-filter>
                                <mat-option [value]="0"> All</mat-option>
                                <mat-option *ngFor="let item of filteredsubjectList" [value]="item.EsId">
                                    {{item.EsName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Name</mat-label>
                            <input  maxlength="150" matInput formControlName="Name1">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Designation</mat-label>
                            <input maxlength="150" matInput formControlName="Designation1">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Name</mat-label>
                            <input  maxlength="150" matInput formControlName="Name2">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Designation</mat-label>
                            <input maxlength="150" matInput formControlName="Designation2">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Name</mat-label>
                            <input  maxlength="150" matInput formControlName="Name3">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Designation</mat-label>
                            <input maxlength="150" matInput formControlName="Designation3">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Name</mat-label>
                            <input  maxlength="150" matInput formControlName="Name4">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Designation</mat-label>
                            <input maxlength="150" matInput formControlName="Designation4">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Name</mat-label>
                            <input  maxlength="150" matInput formControlName="Name5">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Designation</mat-label>
                            <input maxlength="150" matInput formControlName="Designation5">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Name</mat-label>
                            <input  maxlength="150" matInput formControlName="Name6">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Designation</mat-label>
                            <input maxlength="150" matInput formControlName="Designation6">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 row ">
                         
                        <div class="col-sm-12 prpl">
                            <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    {{'header.faculty-data.titleList.Back'
                                    | translate}}
                                </span>
                            </button>
                            <button (click)="Print()" id="Save" type="button" class="btn btn-primary btn-icon-text floatright mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 5px;">
                                    Provisional Report Print
                                </span>
                            </button>
                           <button (click)="FinalPrint()" 
                                    id="Save" type="button" 
                                    class="btn btn-primary btn-icon-text floatright mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 5px;">
                                    Final Report Print
                                </span>
                            </button>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>